import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

// Estructura de un atajo de teclado registrado en la paleta de comandos
export interface ShortcutCommand {
  key: string;
  label: string;
  description: string;
}

// Servicio que centraliza los atajos de teclado de la aplicacion.
// Escucha eventos a nivel de documento y emite en los Subjects correspondientes
// para que los componentes reaccionen sin acoplarse entre si.
@Injectable({
  providedIn: 'root',
})
export class KeyboardShortcutService implements OnDestroy {
  // Se emite cuando el usuario presiona Ctrl+Shift+N para abrir el modal de creacion
  readonly openNew$ = new Subject<void>();

  // Se emite cuando el usuario presiona ESC para cerrar el modal activo
  readonly closeModal$ = new Subject<void>();

  // Lista de atajos que se muestra en la paleta de comandos del header
  private commands: ShortcutCommand[] = [
    { key: 'Ctrl K',       label: 'Buscar',          description: 'Enfocar el buscador del header' },
    { key: '/',            label: 'Buscar en tabla', description: 'Enfocar el buscador de la tabla activa' },
    { key: 'Ctrl Shift A', label: 'Nuevo registro',  description: 'Abrir el formulario de creación' },
    { key: 'Ctrl Shift F', label: 'Vista rápida',   description: 'Buscar y abrir el detalle de un registro' },
    { key: 'Ctrl Shift E', label: 'Edición rápida', description: 'Buscar y abrir el formulario de edición de un registro' },
    { key: 'Esc',          label: 'Cerrar',          description: 'Cerrar modal o palette abierto' },
  ];

  private handleKeyDown = (event: KeyboardEvent) => {
    // ESC cierra el modal activo
    if (event.key === 'Escape') {
      this.closeModal$.next();
      return;
    }

    // Ctrl+Shift+N (o Cmd+Shift+N en Mac) abre el modal de creacion
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'N') {
      event.preventDefault();
      this.openNew$.next();
      return;
    }
  };

  constructor() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  // Devuelve una copia de los atajos para mostrar en la paleta
  getCommands(): ShortcutCommand[] {
    return [...this.commands];
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
